// PRD 3.1: 流式输出体验 —— SSE 协议解析
// 输入: fetch Response.body (ReadableStream)
// 输出: AsyncIterable<{event: string, data: string}>
//
// 为什么要单独解析：浏览器原生 EventSource 只支持 GET 请求，
// 不适用于 POST + body 的 chat 场景，所以需要从 fetch 流手动解析 SSE 帧。

/**
 * @param {Response} response
 * @returns {AsyncGenerator<{event: string, data: string}>}
 */
export async function* parseSSE(response) {
  if (!response.body) throw new Error('response has no body');

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });

    // SSE 事件以空行（\n\n）分隔；按分隔切分，最后一段可能不完整，留在 buffer
    const events = buffer.split('\n\n');
    buffer = events.pop() ?? '';

    for (const rawEvent of events) {
      const parsed = parseEvent(rawEvent);
      if (parsed) yield parsed;
    }
  }

  // 收尾：刷新残留 buffer
  if (buffer.trim()) {
    const parsed = parseEvent(buffer);
    if (parsed) yield parsed;
  }
}

/**
 * 解析单个 SSE 事件块
 * @param {string} rawEvent
 * @returns {{event: string, data: string} | null}
 */
function parseEvent(rawEvent) {
  const lines = rawEvent.split('\n');
  let event = 'message';
  const dataLines = [];

  for (const line of lines) {
    if (line.startsWith(':')) continue; // SSE comment / heartbeat
    if (line.startsWith('event:')) {
      event = line.slice(6).trim();
    } else if (line.startsWith('data:')) {
      // data: 后可有可无一个前导空格，需去掉
      dataLines.push(line.slice(5).replace(/^ /, ''));
    }
  }

  if (dataLines.length === 0) return null;
  return { event, data: dataLines.join('\n') };
}
